import { inject } from '@angular/core';
import {
  ControlContainer,
  FormControlDirective,
  FormControlName,
  FormGroup,
  NgControl,
  NgForm,
  NgModel,
} from '@angular/forms';

export const injectNgControl = () => {
  const ngControl = inject(NgControl, { self: true, optional: true });

  if (!ngControl) {
    throw new Error('Provide a form control');
  }

  if (
    ngControl instanceof FormControlDirective ||
    ngControl instanceof FormControlName ||
    ngControl instanceof NgModel
  ) {
    return ngControl;
  }

  throw new Error('Provide a form control instance');
};

export const injectNgForm = () => {
  const ngForm = inject(ControlContainer, { self: true, optional: true });

  if (!ngForm) {
    throw new Error('Provide a form group');
  }

  return ngForm;
};
